"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCommonContext = buildCommonContext;
const browser_core_1 = require("@datadog/browser-core");
function buildCommonContext() {
    if (browser_core_1.isWorkerEnvironment) {
        return {};
    }
    return {
        view: {
            referrer: document.referrer,
            url: window.location.href,
        },
    };
}
//# sourceMappingURL=commonContext.js.map